import { useParams } from 'react-router';
import { ListItemDecorator, Tab, TabList, TabPanel, Tabs, tabClasses } from "@mui/joy";
import { EmailEditor } from '../components/EmailIntegration/EmailEditor';
import { EmpresaGeneralInfo } from '../features/empresas/EmpresaGeneralInfo/components';
import { EmpresaFullInfo } from '../components/EmpresaComponents/EmpresaInfo';
import { TaskManager } from '../components/TareasComponents/TaskIntegration/TaskManager';
import { TaskManagerProvider } from '../context/TaskManagerContext';
import { useErrorHandling } from 'src/features/empresas/EmpresaDetails/context/ErrorHandlingContext';
import { EmpresaNotFound } from 'src/features/empresas/EmpresaDetails/components/EmpresaNotFound';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';

export function EmpresaDetails() {
	const { has404Error } = useErrorHandling();
	const { id } = useParams();
	const empresaId = parseInt(id ?? "0");

	if (has404Error)
		return (<EmpresaNotFound />);

	return (
		<div className="h-full">
			<div className="flex flex-col grid-cols-3 grid-rows-4 h-full">
				{/* Informacion general */}
				<EmpresaGeneralInfo 
					empresaId={empresaId}/>

				{/* Informacion especifica */}
				<div className="flex max-h-screen h-full overflow-hidden">
					<EmpresaFullInfo
						empresaId={empresaId} />


					{/* Cosas que se pueden realizar */}
					<div className="col-span-2 row-span-3 bg-gray-100 w-2/3 h-full overflow-hidden flex flex-col">

						<div className="h-full rounded-md m-4 flex-1 overflow-hidden">
							<Tabs
								aria-label="tabs"
								defaultValue={0}
								sx={{ 
									height: "100%",
									bgcolor: "transparent",
									"--Tab-indicatorThickness": "2px"
								}}>
								<TabList
									sx={{
										[`& .${tabClasses.root}[aria-selected="true"]`]: {
											boxShadow: 'sm',
											bgcolor: "rgba(156, 163, 175, 0.3)",
										},
										bgcolor: "white",
										color: "red",
										fontWeight: 600,
										borderWidth: "2px 2px 0 2px",
										borderColor: "#d1d5db",
										borderRadius: "6px 6px 0 0",
									}}>
									<Tab>
										<div className="flex items-center gap-x-[2px]">
											<ListItemDecorator>
												<TaskAltRoundedIcon sx={{ color: "rgb(17, 24, 39)", height: 20, width: 20 }}/>
											</ListItemDecorator>
											<p>Tareas</p>
										</div>
									</Tab>
									<Tab>
										<ListItemDecorator>
											<EmailRoundedIcon sx={{ color: "rgb(17, 24, 39)", height: 25, width: 25 }}/>
										</ListItemDecorator>
										Correo
									</Tab>
								</TabList>

								<TabPanel value={0} sx={{ padding: 0, overflow: "hidden" }}>
									<TaskManagerProvider currentEmpresaId={empresaId}>
										<TaskManager />
									</TaskManagerProvider>
								</TabPanel>
								<TabPanel value={1} sx={{ padding: 0 }}>
									<EmailEditor />
								</TabPanel>

							</Tabs>

						</div>

					</div>

				</div>
			</div>
		</div>
	);
}